<template>
    <div class="sub_contents">
        <div class="cont_center">
            <h2 class="title_page">회원 로그인</h2>

            <div class="login_box_area">
                <!-- <h3 class="title_login">
                    Hi-Vitamin<br>Membership
                </h3> -->

                <div class="login_input_area">
                    <ul class="login_menu_list">
                        <li class="on">
                            <RouterLink to="/HFO_LO_002">아이디 찾기</RouterLink>
                        </li>
                        <li>
                            <RouterLink to="/HFO_LO_005">비밀번호 찾기</RouterLink>
                        </li>
                    </ul>

                    <ul class="login_input_list">
                        <li>
                            <h3 class="title_input">이메일</h3>

                            <InputText id="email" :placeholder="placeholderID" />

                            <!-- <p class="required">이메일 형식이 맞지 않습니다. 다시 입력해주세요</p> -->
                        </li>
                        <!-- <li>
                            <h3 class="title_input">휴대전화</h3>

                            <InputText :placeholder="placeholderPhone" />

                            <p class="required">‘-’ 하이픈 없이 숫자만 입력해주세요.</p>
                        </li> -->
                    </ul>

                    <div class="btn_login_area">
                        <button class="btn_type2" @click="getId">확인</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <AlertPopup v-model="alertRequiredShow" :title="alertTitle">
        <template #layer_content>
            <p class="alert_txt" id="alert_txt">
                {{ alertContent }}
            </p>
        </template>
    </AlertPopup>
</template>

<script>
import InputText from '@/components/InputText'
import { postAxios } from '@/lib/AxiosCall';
import AlertPopup from '@/components/AlertPopup.vue';

export default {
    components: {
        InputText,
        AlertPopup
    },
    data() {
        return {
            placeholderID: '가입 할때 등록한 이메일을 입력해주세요',
            placeholderPhone: '‘-’ 없이 번호만 입력해 주세요.',
            alertRequiredShow: false
        }
    },
    methods: {
        async getId() {

            if (document.querySelector("#email").value == '') {
                this.alertContent = '이메일을 입력해 주세요'
                this.alertTitle = '알림'
                this.alertRequiredShow = true;
                return false;
            }

            const response = await postAxios('bgm/v1/mem/search/id', {
                "email": document.querySelector("#email").value,
                "authType": "email"
            });

            if (response.id !== '') {
                this.alertTitle = '가입할때 사용한 ID 입니다'
                this.alertContent = response.id;
                this.alertRequiredShow = true;
            }
            console.log(response);
        }
    }
}
</script>